import {
  getPendingRequestsQuantity,
  PendingRequestsQuantity,
} from "@/services/pending-requests.service";
import { useEffect, useState } from "react";
import { usePolling } from "@/hooks/usePolling";

export enum RequestClass {
  FINANCIAL = "FINANCIAL",
  GRANARY = "GRANARY",
}

export const usePendingRequestsQuantity = (request_class: RequestClass, isActive: boolean) => {
  const [loadingPendingRequestsQuantity, setLoadingPendingRequestsQuantity] =
    useState<boolean>(false);
  const [pendingRequestsQuantity, setPendingRequestsQuantity] =
    useState<PendingRequestsQuantity | null>(null);
  const [pendingRequestsQuantityError, setPendingRequestsQuantityError] =
    useState<unknown>(null);

  const getPendingFinancialRequests = async () => {
    try {
      setLoadingPendingRequestsQuantity(true);
      setPendingRequestsQuantityError(null);

      const response = await getPendingRequestsQuantity();
      setPendingRequestsQuantity(response);
    } catch (error) {
      setPendingRequestsQuantityError(error);
    } finally {
      setLoadingPendingRequestsQuantity(false);
    }
  };

  const callSection = async () => {
    if (request_class === RequestClass.FINANCIAL) {
      await getPendingFinancialRequests();
    }
  };

  useEffect(() => {
    if (isActive) callSection();
  }, [request_class, isActive]);

  usePolling({
    callback: () => {
        if (!loadingPendingRequestsQuantity) callSection()
    },
    isActive,
    delay: 30000
  })

  return {
    pendingRequestsQuantity,
    loadingPendingRequestsQuantity,
    pendingRequestsQuantityError,
  };
};
